<template>
  <b-modal
    ref="searchcodeModal"
    :title="$t('diagnosis.btns.searchCod')"
    centered
    modal-class="searchcode-modal"
  >
    <b-row class="px-3 mt-3">
      <b-col>
        <b-card class="py-5 text-center">
          Content here
        </b-card>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            qa="search-code-modal-save-button"
            @click="hide"
          >
            <i
              class="fal fa-save mr-2"
              aria-hidden="true"
            />
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'SearchcodeModal',
    props: {
        sample: Object
    },
    data() {
        return {
            selected: null,
            options: [
                { value: 'a', text: 'Opción 1' },
                { value: 'b', text: 'Opción 2' },
                { value: 'b', text: 'Opción 3' }
            ]
        }
    },
    methods: {
        show() {
            this.$refs.searchcodeModal.show()
        },
        hide() {
            this.$refs.searchcodeModal.hide()
        }
    }
}
</script>

<style lang="scss">
.searchcode-modal .modal-dialog {
  max-width: 55% !important;
}
</style>

<style lang="scss" scoped>
</style>
